import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordComponent } from './forgot-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorModule } from '../../elements/error/error.module';
@NgModule({
  declarations: [
    ForgotPasswordComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    CommonModule
  ],
  exports: [ForgotPasswordComponent]
})
export class ForgotPasswordModule { }
